import type { OS, Arch } from "./detectOS";

export interface Installer {
  /** Display name for the platform, e.g. "Mac" / "Windows" / "Linux". */
  platform: string;
  url: string;
  label: string;
  meta: string;
}

export type InstallerKey = "mac" | "windows" | "linux-x86_64" | "linux-aarch64";

// NOTE: page-gated v1 (static asset URLs). A later PR (download hardening)
// replaces `url` with a short-lived signed URL minted per entitled session.
const BASE = "https://downloads.steerly.ai";

export const INSTALLERS: Record<InstallerKey, Installer> = {
  mac: {
    platform: "Mac",
    url: `${BASE}/Steerly-latest.dmg`,
    label: "Download Steerly for Mac",
    meta: "macOS 12+ · Apple Silicon & Intel",
  },
  windows: {
    platform: "Windows",
    url: `${BASE}/Steerly-latest.exe`,
    label: "Download Steerly for Windows",
    meta: "Windows 10/11 · x64",
  },
  "linux-x86_64": {
    platform: "Linux",
    url: `${BASE}/Steerly-latest-x86_64.AppImage`,
    label: "Download Steerly for Linux (x64)",
    meta: "AppImage · x86_64 · glibc",
  },
  "linux-aarch64": {
    platform: "Linux",
    url: `${BASE}/Steerly-latest-aarch64.AppImage`,
    label: "Download Steerly for Linux (ARM64)",
    meta: "AppImage · aarch64 · glibc",
  },
};

/** Stable display order for enumerating the platforms in the download UI. */
export const PLATFORM_KEYS: InstallerKey[] = ["mac", "windows", "linux-x86_64", "linux-aarch64"];

/** Map a detected OS (+ arch for Linux) to the installer to feature. */
export function pickInstaller(os: OS, arch: Arch): InstallerKey {
  if (os === "windows") return "windows";
  if (os === "linux") return `linux-${arch}`;
  return "mac"; // "mac" and "other" both default to the Mac build
}
